import React, { Component } from 'react'
import { Grid, Row, Col } from 'react-bootstrap'

import NewDeliveries from './NewDeliveries'
import ListDeliveries from './ListDeliveries'

const fullSize = { xs: 12, lg: 12, md: 12 }

const DeliveryAdministration = () => (
  <Grid fluid>
    <Row>
      <Col {...fullSize}>
        <h4>Skapa leveranser</h4>
      </Col>
      <Col {...fullSize}>
        <NewDeliveries />
      </Col>
    </Row>

    <br />
    <br />
    <hr style={{ border: '1px solid grey' }} />
    <br />
    <br />

    <Row>
      <Col {...fullSize}>
        <ListDeliveries />
      </Col>
    </Row>
  </Grid>
)

export default DeliveryAdministration
